import { getDependentPaths } from 'app/modules/fintracStr/formUtils';
import {
  FintracFormFieldConditional,
  FintracFormSingleField,
} from 'app/modules/fintracStr/models';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

export const fintracStrPersonDetailsFields = (
  hideIfTrue?: FintracFormFieldConditional,
): FintracFormSingleField[] => [
  [
    {
      type: U21FormFieldTypes.TEXT,
      name: 'givenName',
      label: 'Given name',
      mustExistInPayload: false,
      mustHaveValueIfExist: false,
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          hideIfTrue ? [hideIfTrue] : undefined,
          undefined,
          sectionIndex,
          fieldSectionIndex,
        ),
      hideIfTrue,
    },
    {
      type: U21FormFieldTypes.TEXT,
      name: 'surname',
      label: 'Surname',
      mustExistInPayload: false,
      mustHaveValueIfExist: false,
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          hideIfTrue ? [hideIfTrue] : undefined,
          undefined,
          sectionIndex,
          fieldSectionIndex,
        ),
      hideIfTrue,
    },
  ],
  {
    type: U21FormFieldTypes.TEXT,
    name: 'otherNameInitial',
    label: 'Other name initial',
    mustExistInPayload: false,
    mustHaveValueIfExist: false,
    dependentPaths: (sectionIndex, fieldSectionIndex) =>
      getDependentPaths(
        hideIfTrue ? [hideIfTrue] : undefined,
        undefined,
        sectionIndex,
        fieldSectionIndex,
      ),
    hideIfTrue,
  },
];
